<div 
    class="modal fade show" 
    [ngClass]="{'expanded': isExpanded}"
    id="config-modal" 
    tabindex="-1" 
    aria-labelledby="config-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Customers</h4>
                        <!-- <h4 class="modal-title mb-0 item-id">{{ gridType === 'config' ? 'Configurations' : 'Customers' }}</h4> -->
                    </div>
                    <div class="btns-header ms-auto">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        <div class="row mb-3" *ngIf="USER?.role === userRoles.iscManager || USER?.role === userRoles.isc || USER?.role === userRoles.IscSupervisor">
                            <div class="col field">
                                <label>Customer Name:<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="Customer Name"
                                    (change)="this.customerName = $event.value"
                                ></ejs-textbox>
                                <div class="field-error" *ngIf="validationApplied && !this.customerName">First Name is required</div>
                            </div>
                            <div class="col field">
                                <label>City:<span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="City"
                                    (change)="this.city = $event.value"
                                ></ejs-textbox>
                                <div class="field-error" *ngIf="validationApplied && !this.city">City is required</div>
                            </div>
                            <div class="col field">
                                <label>State: <span class="required-asterik">*</span></label>
                                <ejs-textbox
                                    placeholder="State"
                                    (change)="this.state = $event.value"
                                ></ejs-textbox>
                                <div class="field-error" *ngIf="validationApplied && !this.state">State is required</div>
                            </div>
                            <div class="col field">
                                <label>Zip Code:</label>
                                <ejs-textbox
                                    placeholder="Zip Code"
                                    (change)="this.zipCode = $event.value"
                                ></ejs-textbox>
                            </div>
                            <div class="col field">
                                <label>Address:</label>
                                <ejs-textbox
                                    placeholder="Address"
                                    (change)="this.address = $event.value"
                                ></ejs-textbox>
                            </div>
                            <div class="col">
                                <button class="btn btn-sm btn-success" (click)="getCustomers($event)"> Search</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <ejs-grid 
                            *ngIf="mainGrid"
                            #serviceOrderGrid
                            [height]="gridHeight"
                            [allowPaging]="false" [enableInfiniteScrolling]="true" [enableVirtualization]="false" [enableVirtualMaskRow]="false" [infiniteScrollSettings]="infiniteScrollSettings"
                            [query]="query"
                            [pageSettings]="mainGrid.pageSettings"
                            [dataSource]="data" 
                            [allowFiltering]="true"
                            [allowReordering]="true"
                            [allowSorting]="true" 
                            [allowResizing]="true" 
                            [toolbar]="$safeNavigationMigration(mainGrid?.toolbar)"
                            [filterSettings]="{ type: 'Menu' }"
                            [allowSelection]='true'
                            (toolbarClick)="toolbarClick($event, serviceOrderGrid)"
                            (commandClick)="onCommandClick($event)"
                            (rowSelected)='rowSelected($event)'
                            (dataBound)="onDataBound()" (created)="onGridCreated($event)"
                            (actionBegin)="onGridActionBegin($event)"
                            (actionComplete)="onGridActionComplete($event, serviceOrderGrid)"
                            >
                            <e-columns>
                                <e-column 
                                    *ngFor="let column of mainGrid.columns;" 
                                    [field]="column.field" 
                                    [headerText]="column.headerText" 
                                    [clipMode]="'EllipsisWithTooltip'"
                                    [type]="column.type"
                                    [width]="column.width"
                                    [format]="column.format ? column.format : null"
                                    [filterType]="'contains'"
                                    [textAlign]="column.textAlign" 
                                    [visible]="column.visible"
                                    [commands]="column?.commands ? column.commands : null"
                                    [filter]="column.filter ? column.filter : { type: 'Menu' }"
                                    [freeze]="column.freeze ? column.freeze: null"
                                    [allowEditing]="column.allowEditing" 
                                    [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true"
                                    [allowSorting]="column.allowSorting !== undefined ? column.allowSorting : true"
                                    [allowReordering]="column.allowReordering !== undefined ? column.allowReordering : true"
                                    >
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                        <div *ngIf="mainGrid" class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
                            <div class="grid-total-count" style="font-weight:600;">
                                Total Records: {{totalRecords | number}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
                <!-- <button type="button" class="btn btn-sm btn-success" [disabled]="!selectedRowData" (click)="proceed()">Proceed</button> -->
            </div>
        </div>
    </div>
</div>